/**
 * Natural language search is available in non-prod by default, or when
 * REACT_APP_NL_SEARCH_ENABLED=true (production enable flag).
 * REACT_APP_ENVIRONMENT values mirror backend: dev | test | production.
 */
export function isNaturalLanguageSearchEnabled() {
  if (String(process.env.REACT_APP_NL_SEARCH_ENABLED || '').toLowerCase() === 'true') {
    return true;
  }
  const env = String(process.env.REACT_APP_ENVIRONMENT || '').toLowerCase();
  return env === 'dev' || env === 'test';
}
